<template>
  <div
    id="bg-backdrop-overlay"
    @click="closeMenu"
    v-if="isMenuOpen"
    class="backdrop-overlay"
  ></div>
  <aside :class="`${isMenuOpen ? 'is-expanded' : ''}`">
    <div class="menu aside-menu !text-[#386F99]">
      <template v-for="item in menuItems" :key="item.name">
        <a
          v-if="item.isExternal || activeSection === 'crash'"
          :href="getUrlCrash()"
          target="_blank"
          class="button"
          @click="closeMenu"
        >
          <span class="sidebar-icon">
            <i :class="item.icon"></i>
          </span>
          <span class="text !text-[#000] !font-semibold">{{
            item.label || item.name
          }}</span>
        </a>

        <router-link
          v-else
          @click="closeMenu"
          :to="getRouteLocation(item)"
          class="button"
          :class="{ 'router-link-exact-active': isItemActive(item) }"
        >
          <span class="sidebar-icon">
            <i :class="item.icon"></i>
          </span>
          <span class="text !text-[#000] !font-semibold">{{
            item.label || item.name
          }}</span>
        </router-link>
      </template>
    </div>

    <div class="menu">
      <div class="button c-pointer" @click="logout">
        <span class="sidebar-icon">
          <i class="fa-solid fa-right-from-bracket"></i>
        </span>
        <span class="text">Logout</span>
      </div>
    </div>
  </aside>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import {
  categoriesMenuConfig,
  buildNavigationRoute,
} from "@/config/categoriesMenu";
import { getActiveCategory } from "@/helpers/databaseMapping";
import { getUrlCrash } from "@/helpers/appConfiguration";

export default {
  name: "SideBar",
  setup() {
    const store = useStore();
    const route = useRoute();

    const activeSection = computed(() => {
      if (route.meta?.section) return route.meta.section;
      const path = route.path || "";
      if (path.includes("/livecasino")) return "livecasino";
      if (path.includes("/instant")) return "instant";
      if (path.includes("/slot")) return "slot";
      return getActiveCategory() || "slot";
    });

    const menuItems = computed(() => {
      const currentCat = categoriesMenuConfig.categories.find(
        (c) =>
          c.section === activeSection.value || c.id === activeSection.value,
      );
      if (currentCat && currentCat.items) {
        return currentCat.items;
      }

      const slotCat = categoriesMenuConfig.categories.find(
        (c) => c.section === "slot" || c.id === "slot",
      );
      return slotCat?.items || [];
    });

    const closeMenu = () => {
      store.commit("setIsMenuOpen", false);
    };

    const getRouteLocation = (item) => {
      return buildNavigationRoute(item, route, store);
    };

    const isItemActive = (item) => {
      if (route.name === item.routeName) return true;
      if (
        activeSection.value === "slot" &&
        item.routeName === "Home" &&
        (route.name === "Home" || route.path?.endsWith("/slot"))
      ) {
        return true;
      }
      if (
        activeSection.value === "livecasino" &&
        item.routeName === "LiveCasinoHome" &&
        (route.name === "LiveCasinoHome" || route.path?.endsWith("/livecasino"))
      ) {
        return true;
      }
      if (
        activeSection.value === "instant" &&
        item.routeName === "InstantHome" &&
        (route.name === "InstantHome" || route.path?.endsWith("/instant"))
      ) {
        return true;
      }
      return false;
    };

    const logout = () => {
      try {
        localStorage.removeItem("botokentheear");
        window.location.reload();
      } catch (error) {
        console.error("Error during logout:", error.message);
      }
    };

    return {
      activeSection,
      menuItems,
      closeMenu,
      getRouteLocation,
      isItemActive,
      getUrlCrash,
      logout,
      isMenuOpen: computed(() => store.getters.isMenuOpen),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/components/sidebar.scss";

.sidebar-icon {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.15rem;
  color: #386f99;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.button {
  &:hover {
    .sidebar-icon {
      color: var(--primary-color, #6b8ef1) !important;
    }
  }

  &.router-link-exact-active {
    .sidebar-icon {
      color: var(--primary-color, #6b8ef1) !important;
    }
  }
}
</style>
